<template>
  <div class="vue-component-holder">
    <!--[if lt IE 8]>
    <p class="browserupgrade">You are using an <strong>outdated</strong> browser. Please <a href="http://browsehappy.com/">upgrade your
      browser</a> to improve your experience.</p>
    <![endif]-->


    <!-- Page -->
    <div class="page" data-animsition-in="fade-in" data-animsition-out="fade-out">
      <div class="page-content">
        <div class="page-brand-info">
          <div class="brand">
            <img class="brand-img" src="/static/assets/images/repnode-logo-02.svg" alt="...">
          </div>
          <p class="font-size-20">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
            tempor incididunt ut labore et dolore magna aliqua.</p>
        </div>

        <div class="page-login-main animation-slide-right animation-duration-1">
          <div class="brand hidden-md-up">
            <img class="brand-img" src="/static/assets/images/repnode-logo-02-colored.svg" alt="...">
          </div>
          <h3 class="font-size-24">Dokončení registrace</h3>

          <alert ref="alert"/>

          <p v-if="tokenVerified && !success">Pro dokončení registrace prosíme doplňte informace níže</p>
          <p v-if="success">
            Nyní se můžete
            <router-link :to="{name: 'SignInPage'}">přihlásit do aplikace</router-link>
          </p>

          <cr-form
            v-if="tokenVerified && !success"
            :defaultData="defaultData"
            @showMessage="showMessage"/>

          <!--<p>No account? <a href="register-v2.html">Sign Up</a></p>-->

          <footer class="page-copyright">
            <p>© 2020 Repnode. All RIGHT RESERVED.</p>
          </footer>
        </div>

      </div>
    </div>
    <!-- End Page -->


  </div>
</template>

<script>
import crForm   from './CompleteRegistrationForm'
import alert    from '../alert'
import Qs       from 'query-string'
import { http } from '@/http'

export default {
  components: { crForm, alert },
  data () {
    return {
      token:         this.$route.params.token,
      tokenVerified: false,
      defaultData:   {},
      success:       false
    }
  },
  methods:    {
    showMessage (data) {
      this.$refs.alert.showMessage(data)
    },
    verifyToken () {
      let callback = (latitude, longitude) => {

        let d = {
          token: this.token
        }

        if (latitude && longitude) {
          d.CurrentLatitude  = latitude
          d.CurrentLongitude = longitude
        }

        let data = Qs.stringify(d)

        http.post(
          `User/VerifyEmail`,
          data,
          {
            headers: {
              'Content-type': 'application/x-www-form-urlencoded'
            }
          }
        )
          /* zpracovani pozadavku */
            .then(response => {
              if (response.status === 200) {
                this.defaultData = response.data.value

                this.tokenVerified = true
                this.$store.commit('setUser', { response: response.data.value })

                http.defaults.headers.appName       = this.$store.getters.urlAppName
                http.defaults.headers.Authorization = this.$store.getters.user.identity.tokenType + ' ' +
                  this.$store.getters.user.identity.accessToken
                let alertData                       = {
                  message: 'Váš e-mail ' + this.defaultData.email + ' byl ověřen',
                  type:    'success'
                }
                this.$refs.alert.showMessage(alertData)
              }
              else {
                this.tokenVerified = false

                let alertData = {
                  message: 'Váš e-mail se nepodařilo ověřit. Registraci není možné dokončit',
                  type:    'error'
                }
                this.$refs.alert.showMessage(alertData)
              }
            })

            .catch(e => {
              this.tokenVerified = false

              let alertData = {
                message: 'Váš e-mail se nepodařilo ověřit. Registraci není možné dokončit',
                type:    'error'
              }
              this.$refs.alert.showMessage(alertData)
            })
      }

      navigator.geolocation.getCurrentPosition((position) => {
        let latitude  = position.coords.latitude,
            longitude = position.coords.longitude

        callback(latitude, longitude)
      }, () => {
        callback(null, null)
      })
    }
  },
  created () {
    this.verifyToken()

    document.body.classList.add('animsition')
    document.body.classList.add('page-login-v2')
    document.body.classList.add('layout-full')
    document.body.classList.add('page-dark')
    document.body.classList.remove('dashboard')
  }
}
</script>

<style scoped>
@import '../../../assets/login-v2.css';

</style>
